const decodeBasicHtmlEntities = (value: string) =>
  value
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'");

const decodeNumericEntities = (value: string) =>
  value.replace(/&#(?:x([0-9a-fA-F]+)|(\d+));/g, (_match, hex, dec) => {
    const codePoint = Number.parseInt(hex ?? dec, hex ? 16 : 10);
    if (
      Number.isNaN(codePoint) ||
      codePoint < 0 ||
      codePoint > 0x10ffff ||
      !Number.isInteger(codePoint)
    ) {
      return _match;
    }
    return String.fromCodePoint(codePoint);
  });

export const decodeHtmlEntities = (value: string) => {
  if (!value) return "";
  if (typeof DOMParser === "undefined") {
    return decodeNumericEntities(decodeBasicHtmlEntities(value));
  }
  const parser = new DOMParser();
  const doc = parser.parseFromString(value, "text/html");
  return doc.documentElement.textContent ?? "";
};
